import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../i18n/useLanguage";
import { OrderItemPackage } from "../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../ui/KeyValue/KeyValue";
import { PackageImages } from "../../../Packages/PackageImages/PackageImages";
import { PackageItemList } from "../../../Packages/Results/PackageItemList";
import { CartPrintPrice } from "../CartPrintPrice";
import { LineItems } from "./LineItems/LineItems";

type OrderItemProps = {
  orderItem: OrderItemPackage;
};

export const CartPrintItemPackage: FunctionComponent<OrderItemProps> = ({
  orderItem,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  return (
    <div className="border border-edge p-4 rounded-section grid grid-cols-9 gap-x-2 items-center">
      <div className="row-span-2 h-full grid gap-1 shrink-0">
        <PackageImages
          className="w-14 h-14 md:w-full md:h-auto text-paper"
          part={orderItem.itemPart}
        />
      </div>
      <h3 className="text-lg font-medium col-span-8">
        {orderItem.itemTitle[language] || orderItem.itemTitle["en"]}
      </h3>
      <div className="col-span-4">
        <KeyValue className="items-start">
          <>{t("searchResults.partNumber")}:</>
          <>{orderItem.itemPart.partDetails.primaryPart.packagePartNumber}</>
        </KeyValue>
        <PackageItemList
          primaryPart={orderItem.itemPart.partDetails.primaryPart}
        />
      </div>
      <CartPrintPrice orderItem={orderItem} />
      <LineItems orderItem={orderItem} />
    </div>
  );
};
